<template>
  <div class="index-container">
    <div class="video-block">
        <video class="video" muted autoplay loop id="video" webkit-playsinline="true" playsinline="true" x5-video-player-type="h5-page">
          <source src="https://ifreepub.oss-cn-hangzhou.aliyuncs.com/video/webside/freedodata_webside_home_page_web_video.mp4" type="video/mp4">
        </video>
        <img src="/static/images/ezgif.com-gif-maker.gif" alt="">
    </div>
    <div class="content-block-wrapper num-statistics">
      <div class="content-block">
        <div class="num-block-wrapper ">
          <p class="num-block"><span class="num-blue">150</span><span class="add"> + </span>家</p>
          <p class="num-type">写字楼</p>
        </div>
        <div class="num-block-wrapper">
          <p class="num-block"><span class="num-blue">100</span><span class="add"> + </span>家</p>
          <p class="num-type">科技园区</p>
        </div>
        <div class="num-block-wrapper">
          <p class="num-block"><span class="num-blue">150</span><span class="add"> + </span>家</p>
          <p class="num-type">综合体</p>
        </div>
        <div class="num-block-wrapper">
          <p class="num-block"><span class="num-blue">50</span><span class="add"> + </span>家</p>
          <p class="num-type">医院</p>
        </div>
        <div class="num-block-wrapper">
          <p class="num-block"><span class="num-blue">50</span><span class="add"> + </span>家</p>
          <p class="num-type">学校</p>
        </div>
      </div>
    </div>
    <div class="content-block-wrapper">
      <div class="content-block text-wrapper">
        <div class="text-block">
          <div class="bi-title wow animate__fadeInLeft">智慧园区是什么</div>
          <div class="text1 wow animate__fadeInLeft" data-wow-delay="0.1s" >智慧园区以“园区+互联网”为理念，融入社交、移动、大数据和云计算，形成复合型城市空间区域</div>
          <img class="yinhao wow animate__fadeInLeft" data-wow-delay="0.2s" >
          <div class="text2 wow animate__fadeInLeft" data-wow-delay="0.3s">
             智慧园区，是指融合新一代信息与通信技术，具备迅捷信息采集、高速信息传输、高度集中计算、智能事务处理和无所不在的服务提供能力，实现园区内及时、互动、整合的信息感知、传递和处理，以提高园区产业集聚能力、企业经济竞争力、园区可持续发展为目标的先进园区发展理念
          </div>
          <a class="btn2 wow animate__fadeInLeft" data-wow-delay="0.4s" href="" >了解典型应用</a>
        </div>
      </div>
      <div class="content-block reticular-block">
        <div class="animate-imgbox">
          <span class="wow  animate__fadeIn" data-wow-offset="-200" data-wow-duration="1.1s" >创客</span>
          <span class="wow  animate__fadeIn" data-wow-offset="-200" data-wow-delay="0.1s" >工位</span>
          <span class="wow  animate__fadeIn" data-wow-offset="-200" >企业</span>
          <span class="wow  animate__fadeIn" data-wow-offset="-200" data-wow-duration="1.2s" >访客</span>
          <span class="wow  animate__fadeIn" data-wow-offset="-200" data-wow-delay="0.1s" >班车</span>
          <span class="wow  animate__fadeIn" data-wow-offset="-200" >商户</span>
          <span class="wow  animate__fadeIn" data-wow-offset="-200" data-wow-delay="0.1s" data-wow-duration="1.3s" >机构</span>
          <span class="wow  animate__fadeIn" data-wow-offset="-200" data-wow-duration="1.2s" >门禁</span>
          <span class="wow  animate__fadeIn" data-wow-offset="-200" data-wow-delay="0.1s" >园区</span>
          <span class="wow  animate__fadeIn" data-wow-offset="-200" >政府</span>
          <span class="wow  animate__fadeIn" data-wow-offset="-200" data-wow-delay="0.1s" >公寓</span>
          <span class="wow  animate__fadeIn" data-wow-offset="-200" data-wow-duration="1.2s" >楼宇</span>
          <img class="wow  animate__fadeIn reticular-img" data-wow-delay="1.3s" data-wow-offset="-200" src="static/images/index/bi-img1.png" alt="">
        </div>
      </div>
    </div>
    <div class="content-block-wrapper">
      <div class="content-block prod-li-block flex-col">
        <div class="tit wow animate__fadeInLeft">产品</div>
        <ul class="list">
            <li :value="`parent-${index}`" class="wow animate__fadeInLeft" v-for="(item,index) in produceList" @mouseover="mouseOverFunc(item,index)" @mouseout="mouseOutFunc(item,index)" :key="`parent-${index}`">{{item.name}}</li>
        </ul>
      </div>
      <div class="content-block prod-type-block">
        <template v-for="(item,index) in produceList">
            <ul class="bi-project-list" :key="`child-ul-${index}`" v-show="currentDomIndex == index">
                <li v-for="(child,childIndex) in item.children" :key="`child-li${childIndex}`">
                    <!-- <em class="el-icon-document"></em> -->
                    <em :class="{[child.icon]:true}"></em>
                    <span>{{child.name}}</span>
                </li>
            </ul>
        </template>
      </div>
    </div>
    <div class="content-block-wrapper practicing-wrapper flex-col">
      <div class="title type2 wow animate__fadeInLeft"> 我们正在实践 </div>
      <h2 class="wow animate__fadeInRight">在30+城市与<span>500+</span>园区达成长期合作，在园区发展的不同阶段提供针对性解决方案，共同见证园区品牌化运作历程</h2>
    </div>
    <div class="content-block-wrapper map-wrapper flex-col">
        <div class="map-block">
            <div class="map" id="map"></div>
        </div>
    </div>
  </div>
</template>

<script>
import {provideServices,produceList} from './data.js';
import { mapState } from "vuex";
import * as echarts from 'echarts';
import {getChartOption} from './index.js';

export default {
  data() {
    return {
      provideServices:provideServices,
      produceList:produceList,
      myChart:null,
      mapName:'china',
      currentDomIndex:0
    }
  },
  computed: {
    ...mapState({
      clientWidth: state => state.module.clientWidth,
    }),
    clientWidth () {
      return this.$store.state.clientWidth || Number(document.documentElement.clientWidth)
    }
  },
  watch: {
    clientWidth(val) {
      let dom = document.querySelector('.reticular-img');
      let num = val > 1920 ? 1 : val / 1920;
      if(dom) {
        console.log(val,num);
        // dom.style.transform = `scale(${num}) translate(-50%, -50%)`;
      }
    }
  },
  mounted() {
    this.initMap();
    document.addEventListener(
        'WeixinJSBridgeReady',
        this.initVideo,
        false
    );
  },
  methods: {
    initMap() {
        let chartDom = document.getElementById('map');
        this.myChart && this.myChart.dispose();
        this.myChart = echarts.init(chartDom);
        let option = getChartOption(this.mapName);
        this.myChart.setOption(option);
    },
    initVideo() {
      let video = document.getElementById("video");
      video.play();
      document.removeEventListener(
        'WeixinJSBridgeReady',
        this.initVideo,
        false
      );
    },
    mouseOverFunc(item,index) {
        this.currentDomIndex = index;
    },
    mouseOutFunc(item,index) {
    },
  },
  beforeDestroy() {
    this.myChart && this.myChart.dispose();
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/css/index.scss';
</style>


// WEBPACK FOOTER //
// src/components/index/index.vue